import React from 'react'

// material ui
import Icon from '@mui/icons-material/InfoOutlined'
import { styled } from '@mui/material/styles'
import { compose, spacing, palette } from '@mui/system'

const StyledIcon = styled(Icon)(compose(spacing, palette))

const InfoLink = ({ onClick }) => {
  return (
    <StyledIcon
      mx={0.5}
      fontSize='small'
      color='text.secondary'
      onClick={onClick}
    />
  )
}

export default InfoLink
